import { Component, OnInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Business } from '@app/modules/model/business';

import { languageSupport, languageService } from '@app/modules/common/language';
import { viewService } from '@app/modules/view';

@Component({
    selector: 'ui-business-thumbnail',
    templateUrl:'./ui-thumb.html',
    styleUrls: [ 
        './ui-thumb.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiBusinessThumbnail extends languageSupport implements OnInit, OnChanges, OnDestroy {
    @Input('business') _business: Business = null;
    @Input('isaccount') _isaccount: boolean = false;

    private _business_subscription = null;

    constructor(private lang: languageService, private change: ChangeDetectorRef, public view: viewService){
        super(lang, change);
    }

    ngOnInit(){
        // nothing to do
    }

    ngOnChanges() {
        if (this._business_subscription){
            this._business_subscription.unsubscribe();
            this._business_subscription = null;
        }

        this._business_subscription = this._business.OnRefresh.subscribe(
        data => {
            this.change.markForCheck();
        });    
    }

    ngOnDestroy(){
        super.OnDestroy();

        if (this._business_subscription){
            this._business_subscription.unsubscribe();
            this._business_subscription = null;
        }        
    }
}
